import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComplaintSuggestionService } from 'src/app/modules/complaints-suggestions/_services/complaints-suggestions.service';
import { catchError } from 'rxjs/operators';
import { HotToastService } from '@ngneat/hot-toast';
import { CaptchaService } from '../_services/CaptchaService.service';

@Component({
  selector: 'app-investment',
  templateUrl: './investment.component.html',
  styleUrls: ['./investment.component.scss']
})
export class InvestmentComponent implements OnInit, OnDestroy {
  language: any;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = [];
  formGroup: FormGroup;
  MobilePattern = "(5)[0-9]{8}";
  NoWhitespacePattern = "^([\u0621-\u064A]+ )+[\u0621-\u064A]+$|^[\u0621-\u064A]+$|^([a-zA-Z]+ )+[a-zA-Z]+$|^[a-zA-Z]+$";
  IDPattern = /^(?=\D*\d)(?=\w{10}$)[\da-zA-Z]*$/;
  EmailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
  captchaCode: string;
  userInput: string = '';
  isValid: boolean | undefined;
  selectedAreas: string = '';  // This will hold the comma-separated selected values
selectedStructure:string='';
IsAreasOfInvestmentInterestOther:boolean = false;
IsPreferredInvestmentStructure:boolean = false;

  constructor(private ComplaintSuggestionService: ComplaintSuggestionService,private fb: FormBuilder,
     private translationService: TranslationService,private toast: HotToastService,private captchaService: CaptchaService) { }

  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.loadForm();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isLoading$ = this.ComplaintSuggestionService.isLoading$;
  }
  refreshCaptcha() {
    this.captchaService.generateCaptcha();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isValid = undefined;
  }

  validateCaptcha() {
    this.isValid = this.captchaService.validateCaptcha(this.userInput);
  }
  onCheckboxChange(event: any) {
    
    const value = event.target.value;
    
    if (event.target.checked) {
      // If the checkbox is checked, add the value to the string
      if (this.selectedAreas) {
       
        this.selectedAreas += `, ${value}`;
      } else {
        this.selectedAreas = value;
      }
      if (value == 'Other')
        {
          this.IsAreasOfInvestmentInterestOther = true;
        }
    } else {
      // If the checkbox is unchecked, remove the value from the string
      const selectedArray = this.selectedAreas.split(',').map(item => item.trim());
      const index = selectedArray.indexOf(value);
      if (index > -1) {
        selectedArray.splice(index, 1);
      }
      this.selectedAreas = selectedArray.join(', ');
      if (value == 'Other')
        {
          this.IsAreasOfInvestmentInterestOther = false;
        }
    }
  }
  onCheckboxStructureChange(event: any) {
    const value = event.target.value;
    
    if (event.target.checked) {
      // If the checkbox is checked, add the value to the string
      if (this.selectedStructure) {
        this.selectedStructure += `, ${value}`;
      } else {
        this.selectedStructure = value;
      }
      if (value == 'Other')
        {
          this.IsPreferredInvestmentStructure = true;
        }
    } else {
      // If the checkbox is unchecked, remove the value from the string
      const selectedArray = this.selectedStructure.split(',').map(item => item.trim());
      const index = selectedArray.indexOf(value);
      if (index > -1) {
        selectedArray.splice(index, 1);
      }
      this.selectedStructure = selectedArray.join(', ');
      if (value == 'Other')
        {
          this.IsPreferredInvestmentStructure = false;
        }
    }
   
  }
  loadForm() {

    this.formGroup = this.fb.group({
      Id: [0],
      Name: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      Designation: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      CompanyName: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      EmailAddress: ['', [Validators.required, Validators.pattern(this.EmailPattern)]],
      Mobile: ['', [Validators.required,Validators.pattern(this.MobilePattern)]],
      // IndustrySector: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      GeographicFocus: ['0'],
      AreasOfInvestmentInterest: '',
      PreferredInvestmentStructure:'',
      ScheduleMeeting:'',
      MeetingTime:'',
      MeetingDate:'',
      Comment:['',[Validators.maxLength(3000),Validators.pattern('^[a-zA-Z0-9\u0621-\u064A ]+$')]],
      OtherAreasOfInvestmentInterest :'',
      OtherPreferredInvestmentStructure :''

    });
  }
  submit()
  {
    
    this.formGroup.markAllAsTouched();
    if (!this.formGroup.valid) {
      return;
    }
    const formValues = this.formGroup.value;
    formValues.AreasOfInvestmentInterest = this.selectedAreas
    formValues.PreferredInvestmentStructure = this.selectedStructure
    formValues.ScheduleMeeting == '1' ? formValues.ScheduleMeeting = true : formValues.ScheduleMeeting = false;
    formValues.AreasOfInvestmentInterest =  formValues.AreasOfInvestmentInterest.replace('Other', formValues.OtherAreasOfInvestmentInterest);
    formValues.PreferredInvestmentStructure =  formValues.PreferredInvestmentStructure.replace('Other', formValues.OtherPreferredInvestmentStructure);

    this.ComplaintSuggestionService.showLoader();
    const Subscr = this.ComplaintSuggestionService.AddInvestment(formValues).pipe(
      catchError((errorMessage) => {
        this.ComplaintSuggestionService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
  
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
       
      }
      else if (res.isSuccess && res.responseCode == 404) {
        this.toast.warning("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);

  }
 

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
